import React from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { Link } from "react-router-dom"

const WhyUs = () => {
    return (
        <Box>
            <Box marginBottom={4}>
                <Typography
                    sx={{
                        textTransform: "uppercase",
                        fontWeight: "medium",
                    }}
                    gutterBottom
                    color={"secondary"}
                    align={"center"}
                >
                    Why Choose Us
                </Typography>
                <Box
                    component={Typography}
                    fontWeight={700}
                    variant={"h3"}
                    gutterBottom
                    align={"center"}
                    data-aos={"fade-up"}
                >
                    Your trusted partner in finding your dream home and
                    achieving your real estate goals
                </Box>
                <Typography
                    variant={"h6"}
                    component={"p"}
                    color={"textSecondary"}
                    align={"center"}
                    data-aos={"fade-up"}
                >
                    Our dedicated team offers a seamless real estate experience,
                    ensuring you receive personalized service from start to
                    finish. Whether buying or selling, we guide you through
                    every step, leveraging our expertise to deliver exceptional
                    results.
                </Typography>
                <Box
                    marginTop={3}
                    display={"flex"}
                    justifyContent={"center"}
                    data-aos={"fade-up"}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to="/page-contact" // Path to your contact page
                        size="large"
                    >
                        Contact Us
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default WhyUs
